<template>
    <div class="flex flex-col gap-4">
        <div class="flex gap-4">
            <div class="h-[93px] w-[93px] shrink-0 items-start rounded-md">
                <SvgIcon
                    class="h-full w-full"
                    name="taxibox-match-icon"
                />
            </div>

            <div class="flex max-w-[500px] flex-col items-start justify-between gap-1">
                <div class="flex items-center gap-2">
                    <span class="leading-none font-medium">
                        TAXIBOX Self-Pack Container
                        <template v-if="match.matchable?.box_count > 1">
                            &times; {{ match.matchable?.box_count }}
                        </template>
                    </span>
                </div>

                <span class="text-left text-xs">
                    This option requires you to load and unload the TAXIBOX yourself. For full removalist service, speak
                    to a Muval team member.
                </span>

                <div class="flex flex-wrap gap-2">
                    <div
                        class="border-muval-brand text-muval-brand inline-flex items-center gap-1 rounded border border-dashed px-1.5 py-1 whitespace-nowrap"
                    >
                        <div class="flex h-4 w-4 items-center justify-center">
                            <SvgIcon
                                name="system-shopping"
                                class="h-3.5 w-3.5 -rotate-90"
                            />
                        </div>
                        <span class="text-xs font-medium">
                            {{ match.matchable?.muval_discount?.formatted?.replace(/\.00$/, '') }} Muval Offer included
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { MoveMatch } from '@/types';

interface Props {
    match: MoveMatch;
}

defineProps<Props>();
</script>
